import { FC } from 'react';
import { TypographyType } from '@/common/components/base/typography/Typography.type.ts';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { css } from 'styled-system/css';

const TitleDescription: FC<TypographyType> = ({
  children,
  textStyle = 'h2',
  ...props
}) => (
  <Typography textStyle={textStyle} position="relative" pr="12px" {...props}>
    <span
      className={css({
        width: '3px',
        backgroundColor: 'purple-primary',
        borderRadius: '10px',
        position: 'absolute',
        right: 0,
        height: '20px',
      })}
    />
    {children}
  </Typography>
);

export default TitleDescription;
